import type { CatalogTree } from '../types';

export const merchantTabs = {
  period: '{from} – {to}',
  invoices: {
    label: 'Faturalar',
    empty: 'Henüz fatura yok.',
    replaces: 'Yerine geçtiği: {number}',
    pdf: 'PDF',
    reissue: 'Yeniden düzenle',
    kind: { e_arsiv: 'e-Arşiv', e_fatura: 'e-Fatura' },
    columns: {
      number: 'Numara',
      kind: 'Tür',
      period: 'Hizmet dönemi',
      gross: 'Brüt tutar',
      status: 'Durum',
      issuedAt: 'Düzenlenme',
      replaces: 'Yerine geçtiği',
      error: 'Hata',
    },
  },
  usage: {
    current: 'Bu dönem',
    source: { subscription: 'Abonelik dönemi', calendar_month: 'Takvim ayı' },
    periodValue: '{from} – {to} ({source})',
    units: 'Birim',
    allowance: 'Kota',
    unlimited: 'Sınırsız',
    percentLabel: 'Kullanım oranı',
    percent: '{n} %',
    over: 'Sınır aşıldı',
    thresholds: 'Aşılan eşikler',
    threshold: '{n} %: {at}',
    counts: { reply_turn: 'Yanıt turu', draft_turn: 'Taslak turu', image_match: 'Görsel eşleme' },
    history: 'Son 6 dönem',
    historyX: 'Dönem başı',
    cost: 'Maliyet',
    costText: 'Birim bazlı. Maliyet tahmini üretim sağlayıcısı seçilince eklenecek.',
    empty: 'Henüz kullanım yok.',
  },
  users: {
    label: 'Kullanıcılar',
    seats: 'Koltuk',
    seatsValue: '{used} / {limit}',
    readOnly: 'Kullanıcıları işletme sahibi yönetir.',
    empty: 'Kullanıcı yok.',
    status: { invited: 'Davetli', active: 'Aktif', disabled: 'Devre dışı' },
    yes: 'Evet',
    no: 'Hayır',
    columns: {
      name: 'Ad',
      email: 'E-posta',
      role: 'Rol',
      status: 'Durum',
      verified: 'E-posta doğrulandı',
      twoStep: 'İki adımlı',
      lastLogin: 'Son giriş',
      invitedBy: 'Davet eden',
      created: 'Oluşturulma',
    },
    resetTotp: {
      label: 'İki adımlı doğrulamayı sıfırla',
      description:
        'Gizli anahtar ve kurtarma kodları silinir; kullanıcı bir sonraki girişte yeniden kurar.',
      done: 'İki adımlı doğrulama sıfırlandı.',
    },
  },
  notes: {
    title: 'Notlar',
    field: 'Not',
    add: 'Not ekle',
    empty: 'Henüz not yok.',
    audit: 'İşlem geçmişi',
    actionPrefix: 'İşlem öneki',
    auditEmpty: 'Henüz işlem yok.',
  },
  integrations: {
    channels: 'Kanallar',
    noChannels: 'Bağlı kanal yok.',
    store: 'Mağaza',
    noStore: 'Bağlı mağaza yok.',
    adapterValue: '{id} ({version})',
    statusReason: 'Neden: {reason}',
    mode: { auto: 'Otomatik', draft: 'Taslak', off: 'Kapalı' },
    routing: { full: 'Tam', copy_only: 'Yalnız kopya' },
    capabilitiesValue:
      'Yankı: {echoes}; yanıt penceresi: {auto} sa / {manual} sa; referanslar: {references}',
    circuit: { closed: 'Kapalı', open: 'Açık', half_open: 'Yarı açık' },
    circuitUntil: '{state} ({until} kadar)',
    lastErrorValue: '{type}, {at}',
    cursorValue: '{stream}: {cursor} · {watermark}',
    webhookValue: '{stream}: {id}',
    remapStarted: 'Yeniden eşleme başladı',
    fields: {
      adapter: 'Adaptör',
      displayName: 'Görünen ad',
      phone: 'Telefon',
      username: 'Kullanıcı adı',
      status: 'Durum',
      routingMode: 'Yönlendirme',
      mode: 'Asistan modu',
      capabilities: 'Yetenekler',
      connectedAt: 'Bağlanma',
      lastEventAt: 'Son olay',
      credentialsExpiresAt: 'Kimlik bilgisi bitişi',
      platform: 'Platform',
      baseUrl: 'Adres',
      consecutiveFailures: 'Ardışık hata',
      lastError: 'Son hata',
      lastSuccess: 'Son başarı',
      circuit: 'Devre kesici',
      cursors: 'İmleçler',
      lastFullSync: 'Son tam eşitleme',
      lastPriceReread: 'Son fiyat okuma',
      lastReconcile: 'Son mutabakat',
      webhooks: 'Webhook abonelikleri',
      egressIps: 'Çıkış IP adresleri',
    },
    settings: {
      title: 'Akışlar ve bağlayıcı ayarları',
      flag: {
        mapped: 'Eşlenir',
        incremental: 'Artımlı',
        webhook: 'Webhook',
        list_ids: 'Kimlik listesi',
        reread: 'Fiyat yeniden okuma',
      },
      disabledReason: 'Eşitleme bu akışı kapattı:',
      save: 'Kaydet',
      confirmTitle: 'Ayarları kaydet',
      saveText:
        'Ayarlar kaydedilir; bağlayıcı ayarı değiştiyse kayıtlı ham kayıtlar yeniden eşlenir.',
    },
    runs: 'Eşitleme çalıştırmaları',
    noRuns: 'Henüz eşitleme yok.',
    countsValue:
      '{stream}: {fetched} alınan, {unchanged} aynı, {changed} değişen, {deleted} silinen, {failed} hatalı',
    runErrorValue: '{at} · {type}: {message}',
    runColumns: {
      type: 'Tür',
      trigger: 'Tetikleyen',
      status: 'Durum',
      streams: 'Akışlar',
      counts: 'Sayılar',
      errors: 'Hatalar',
      started: 'Başlangıç',
      finished: 'Bitiş',
      duration: 'Süre',
    },
    rules: {
      title: 'Eşleme kuralları',
      kind: 'Kaynak türü',
      name: 'Kaynak adı',
      pattern: 'Desen',
      target: 'Hedef özellik',
      transform: 'Dönüşüm',
      unit: 'Birim',
      save: 'Kaydet',
      saveText: 'Kurallar kaydedilir ve ürünler yeniden eşlenir; mağazaya istek gitmez.',
      saved: 'Kurallar kaydedildi.',
      remap: 'Yeniden eşle',
      remapText: 'Kayıtlı ham kayıtlar mevcut kurallarla yeniden eşlenir.',
      remapStream: 'Akış',
      empty: 'Kural yok.',
      add: 'Kural ekle',
      remove: 'Kuralı kaldır',
      actions: 'İşlemler',
    },
  },
} as const satisfies CatalogTree;
